module.exports = __webpack_public_path__ + "static/media/tns_logo.18215fab.svg";